// PrivacyPolicyPage is now a static page (content owned by the
// translation files), but the route still wires `loadData` through
// pageDataLoadingAPI, so we keep this module exporting a no-op
// instead of removing it. Replace with real fetching if the page
// ever needs server-rendered data again.

export const ASSET_NAME = 'privacy-policy';

export const loadData = () => () => Promise.resolve();
